import PropTypes from 'prop-types';
import cn from 'classnames';

import './TrackingHealthSparkline.scss';

const WIDTH = 120;
const HEIGHT = 28;

const TrackingHealthSparkline = props => {
  const { values } = props;
  if (!values || values.length < 2) return <div className='tracking-health-sparkline tracking-health-sparkline--empty' />;

  const max = Math.max(1, ...values);
  const stepX = WIDTH / (values.length - 1);
  const points = values.map((value, idx) => [idx * stepX, HEIGHT - 1 - (value / max) * (HEIGHT - 2)]);
  const linePath = points.map(([x, y], idx) => `${idx === 0 ? 'M' : 'L'} ${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const areaPath = `${linePath} L ${WIDTH},${HEIGHT} L 0,${HEIGHT} Z`;
  const hasErrors = values.some(value => value > 0);

  return (
    <svg
      className={cn('tracking-health-sparkline', { 'has-errors': hasErrors })}
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      preserveAspectRatio='none'
      aria-hidden='true'
    >
      <path className='tracking-health-sparkline-area' d={areaPath} />
      <path className='tracking-health-sparkline-line' d={linePath} />
    </svg>
  );
};

TrackingHealthSparkline.propTypes = {
  values: PropTypes.arrayOf(PropTypes.number)
};

export default TrackingHealthSparkline;
